import { useEffect, useState } from 'react'
import { getCountdown, parseArrivalDate, type Countdown } from '@/utils/arrivalDate'

export function useCountdown(arrivalDate: string | undefined, active: boolean): Countdown {
  const [countdown, setCountdown] = useState<Countdown>(() =>
    active ? getCountdown(parseArrivalDate(arrivalDate)) : { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true }
  )

  useEffect(() => {
    if (!active || !arrivalDate) {
      setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true })
      return
    }
    const target = parseArrivalDate(arrivalDate)
    let intervalId: ReturnType<typeof setInterval> | null = null
    const tick = () => {
      const next = getCountdown(target)
      setCountdown(next)
      if (next.isExpired && intervalId) clearInterval(intervalId)
    }
    tick()
    intervalId = setInterval(tick, 1000)
    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [active, arrivalDate])

  return countdown
}
